import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useToasts } from 'react-toast-notifications';
import { updateUser } from '../../service/userService';
import { userInfoValidator } from '../../service/validatorForms';
import MainContext from '../context/mainContext';
import { CSSTransition } from 'react-transition-group';
import './EditInformation.css';

const EditInformationUser = () => {
    const [showOptions, setShowOptions] = useState(false);
    const context = useContext(MainContext);
    const validatorRef = useRef(userInfoValidator());
    const fullNameRef = useRef(null);
    const ageRef = useRef(null);
    const addressRef = useRef(null);
    const telephoneRef = useRef(null);
    const [, setForceUpdate] = useState();
    const forceUpdate = useCallback(() => setForceUpdate({}), []);
    const { addToast } = useToasts();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setShowOptions(true);
        return () => setShowOptions(false);
    }, []);

    const submitHandler = async (event) => {
        event.preventDefault();
        try {
            if (validatorRef.current.allValid()) {
                const user = {
                    age: ageRef.current.value,
                    fullName: fullNameRef.current.value,
                    address: addressRef.current.value,
                    telephone: telephoneRef.current.value
                }
                setIsLoading(true);
                const { status, data } = await updateUser(user);
                if (status === 201) {
                    addToast("ویرایش اطلاعات با موفقیت انجام شد", {
                        appearance: 'success',
                        autoDismiss: true,
                    })
                    validatorRef.current.hideMessageFor("age");
                    validatorRef.current.hideMessageFor("description");
                    validatorRef.current.hideMessages();
                    forceUpdate();
                    context.login(data.user)
                }
            }
            else {
                validatorRef.current.showMessages();
                forceUpdate();
            }
        } catch (err) {
            if (err.response && err.response.status === 404) {
                addToast("کاربر با این مشخصات وجود ندارد", {
                    appearance: 'error',
                    autoDismiss: true,
                })
            }
            validatorRef.current.hideMessageFor("age");
            validatorRef.current.hideMessageFor("description");
            validatorRef.current.hideMessages();
            forceUpdate();
        }
        setIsLoading(false);
    }
    return ( 
        <div className="edit-user-page">
            <div className="container">
                <CSSTransition
                    in={showOptions}
                    timeout={300}
                    classNames="Edit-User-Transition"
                    mountOnEnter
                    unmountOnExit
                >
                    <div className="background-edit-user-form shadow-lg px-lg-5">
                        <h4 className="text-center mb-5">ویرایش اطلاعات کاربر</h4>
                        <form onSubmit={submitHandler}>
                            <fieldset disabled={!context.loggedIn}>
                                <div className="form-row">
                                    <div className="form-group col-md-4">
                                        <label htmlFor="inputFullName">
                                            نام و نام خانوادگی
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="inputFullName"
                                            defaultValue={context.loggedIn && context.loggedIn.fullName}
                                            onChange={forceUpdate}
                                            name="fullName"
                                            ref={fullNameRef}
                                            placeholder="نام و نام خانوادگی"
                                            onBlur={() => {
                                                if (fullNameRef.current.value !== '') {
                                                    validatorRef.current.showMessageFor("fullName");
                                                    forceUpdate()
                                                }
                                            }}
                                            onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}
                                        />
                                        {validatorRef.current.message(
                                            "fullName",
                                            fullNameRef.current && fullNameRef.current.value,
                                            "required|max:25"
                                        )}

                                    </div>
                                    <div className="form-group col-md-4">
                                        <label htmlFor="age">
                                            سن
                                        </label>
                                        <input
                                            type="text"
                                            id="age"
                                            className="form-control"
                                            placeholder="سن"
                                            aria-describedby="age"
                                            name="age"
                                            defaultValue={context.loggedIn && context.loggedIn.age}
                                            ref={ageRef}
                                            onChange={forceUpdate}
                                            onBlur={() => {
                                                if (ageRef.current.value !== '') {
                                                    validatorRef.current.showMessageFor("age");
                                                    forceUpdate();
                                                }
                                            }}
                                        />
                                        {validatorRef.current.message(
                                            "age",
                                            ageRef.current && ageRef.current.value,
                                            "required|integer"
                                        )}
                                    </div>
                                    <div
                                        className="form-group col-md-4"
                                        style={{ direction: "ltr" }}
                                    >
                                        <label htmlFor="phoneNumber">تلفن</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="phoneNumber"
                                            name="telephone"
                                            placeholder="051"
                                            defaultValue={context.loggedIn && context.loggedIn.telephone}
                                            ref={telephoneRef}
                                            onChange={forceUpdate}
                                            onBlur={() => {
                                                if (telephoneRef.current.value !== '') {
                                                    validatorRef.current.showMessageFor("telephone");
                                                    forceUpdate();
                                                }
                                            }}
                                        />
                                        {validatorRef.current.message(
                                            "telephone",
                                            telephoneRef.current && telephoneRef.current.value,
                                            "phone"
                                        )}
                                    </div>
                                </div>
                                <div className="form-group ">
                                    <label htmlFor="exampleFormControlTextarea">
                                        آدرس
                                    </label>
                                    <textarea
                                        id="exampleFormControlTextarea"
                                        className="form-control"
                                        rows="5"
                                        placeholder="توضیحات"
                                        defaultValue={context.loggedIn && context.loggedIn.address}
                                        name="address"
                                        aria-describedby="address"
                                        onChange={forceUpdate}
                                        ref={addressRef}

                                        onBlur={() => {
                                            if (addressRef.current.value !== '') {
                                                validatorRef.current.showMessageFor("address");
                                                forceUpdate();
                                            }
                                        }}
                                    ></textarea>
                                    {validatorRef.current.message(
                                        "address",
                                        addressRef.current && addressRef.current.value,
                                        "required"
                                    )}
                                </div>
                                <div className="text-center mt-4">
                                    <button
                                        type="submit"
                                        className="btn btn-success"
                                        style={{ width: "150px" }}
                                        disabled={isLoading}
                                    >
                                        <i
                                            className={isLoading ? 'spinner-border spinner-border-sm mr-2' : ''}
                                            style={{ position: 'relative', bottom: '3px' }}
                                        ></i>
                                        ویرایش اطلاعات
                                    </button>
                                </div>
                            </fieldset>
                        </form>
                    </div>
                </CSSTransition>
            </div>
        </div>
     );
}
 
export default EditInformationUser;